import { createContext, useContext, useState, type ReactNode } from 'react'

export type BranchId = 'all' | 'putrajaya' | 'shah-alam' | 'bangi' | 'kuala-lumpur'

interface Branch {
  id: BranchId
  name: string
}

export const BRANCHES: Branch[] = [
  { id: 'all', name: 'All Branches' },
  { id: 'putrajaya', name: 'Putrajaya' },
  { id: 'shah-alam', name: 'Shah Alam' },
  { id: 'bangi', name: 'Bangi' },
  { id: 'kuala-lumpur', name: 'Kuala Lumpur' },
]

interface BranchContextValue {
  selectedBranch: Branch
  setSelectedBranch: (branch: Branch) => void
  branchId: BranchId
}

const BranchContext = createContext<BranchContextValue | null>(null)

export function BranchProvider({ children }: { children: ReactNode }) {
  const [selectedBranch, setSelectedBranch] = useState<Branch>(BRANCHES[0]!)

  return (
    <BranchContext.Provider
      value={{
        selectedBranch,
        setSelectedBranch,
        branchId: selectedBranch.id,
      }}
    >
      {children}
    </BranchContext.Provider>
  )
}

export function useBranch() {
  const context = useContext(BranchContext)
  if (!context) {
    throw new Error('useBranch must be used within a BranchProvider')
  }
  return context
}
